<template>
  <main class="document-templates">
    <div class="document-templates__body">
      <h1>Шаблоны документов</h1>
      <div class="document-templates__controls">
        <input-text-search
          class="document-templates__search"
          v-bind:value="searchQuery"
          v-on:input="onInputSearchQuery"
          placeholder="Введите название документа"
        />
        <div class="document-templates__buttons-group">
          <button
            v-if="shouldShowCreatePackageButton"
            class="document-templates__button-create-package"
            type="button"
            v-on:click="openCreatePackageModal">Создать пакет</button>
          <button
            v-if="!isCurrentCategoryPackageDocuments"
            class="document-templates__button-add"
            type="button"
            v-on:click="onClickAddTemplate">Добавить</button>
        </div>
      </div>
      <div v-if="hasCategories">
        <div class="document-templates__tables-container">
          <div class="document-templates__categories">
            <div class="document-templates__categories__caption">
              <span>Категории</span>
            </div>
            <div class="document-templates__categories__container">
              <category-item
                v-for="category in categories"
                v-bind:has-delete="true"
                v-bind:has-edit="true"
                v-bind:key="category.id"
                v-bind:selected-category="selectedCategoryId"
                v-bind:category="category"
                v-on:select-category="onSelectCategory"
                v-on:delete-category="onShowDeleteCategoryForm"
                v-on:edit-category="onShowEditCategoryForm"
              />
              <category-item
                v-if="isFdocIntegratonExists"
                v-bind:category="$options.packageDocuments"
                v-bind:has-delete="false"
                v-bind:has-edit="false"
                v-bind:is-await-request="isAwaitRequest"
                v-bind:selected-category="selectedCategoryId"
                v-on:select-category="onSelectPackageDocuments"
              />
              <category-item
                v-bind:category="$options.systemDocuments"
                v-bind:has-delete="false"
                v-bind:has-edit="false"
                v-bind:is-await-request="isAwaitRequest"
                v-bind:selected-category="selectedCategoryId"
                v-on:select-category="onSelectCategory"
              />
            </div>
          </div>
          <div class="document-templates__table">
            <div class="document-templates__table__head">
              <div class="document-templates__table__cell">
                №
              </div>
              <div class="document-templates__table__cell">
                Название документа
              </div>
              <div class="document-templates__table__cell">
                Тип документа
              </div>
              <!--  <div-->
              <!--class="document-templates__table__cell"-->
              <!--v-if="!isCurrentCategoryPackageDocuments &&
              !isCurrentCategorySystemDocuments">-->
              <!--ЕСИА-->
              <!-- </div>-->
              <div class="document-templates__table__cell" />
            </div>
            <template
              v-if="!isCurrentCategoryPackageDocuments">
              <div
                class="document-templates__table__row"
                v-bind:key="index"
                v-for="(template, index) in templates"
              >
                <div class="document-templates__table__cell">{{ index + 1 }}</div>
                <div class="document-templates__table__cell">{{ template.getNameWithPrefix() }}</div>
                <div class="document-templates__table__cell">{{ template.typeName }}</div>
                <div class="document-templates__table__cell">
                  <!--                  <p v-if="template.isEsiaConfirmationRequired">-->
                  <!--                    Да-->
                  <!--                  </p>-->
                </div>
                <div class="document-templates__table__cell">
                  <button
                    class="document-templates__table-row-view"
                    title="Просмотр"
                    type="button"
                    v-if="template.isSample"
                    v-on:click="onClickSampleTemplatePreviewButton(template)" />
                </div>
                <div class="document-templates__table__cell">
                  <button
                    class="document-templates__table-row-edit"
                    title="Изменить шаблон"
                    type="button"
                    v-if="!template.isSample"
                    v-on:click="onClickTemplateEditButton(template)" />
                  <button
                    class="document-templates__table-row-download"
                    title="Скачать"
                    type="button"
                    v-else
                    v-on:click="onClickSampleTemplateDownloadButton(template)" />
                </div>
                <div class="document-templates__table__cell">
                  <button
                    class="document-templates__table-row-remove"
                    title="Удалить шаблон"
                    type="button"
                    v-if="template.isCanBeRemoved"
                    v-on:click="onTemplateRemove(template.removingId, template.typeName)" />
                </div>
              </div>
            </template>
            <template
              v-else>
              <template
                v-if="!isAwaitRequest">
                <div v-if="isPackagesFind">
                  <div
                    class="document-templates__table__row"
                    v-bind:key="index"
                    v-for="(packageDocument, index) in packages"
                  >
                    <div class="document-templates__table__cell">{{ index + 1 }}</div>
                    <div class="document-templates__table__cell">
                      <button
                        class="document-templates__table__cell__button-package-edit"
                        type="button"
                        v-on:click="onClickPackageTemplateEditButton(packageDocument)"
                      >
                        {{ packageDocument.name }}
                      </button>
                    </div>
                    <div class="document-templates__table__cell">-</div>
                    <div class="document-templates__table__cell" />
                    <div class="document-templates__table__cell" />
                    <div class="document-templates__table__cell" />
                  </div>
                </div>
                <div v-else class="document-templates__empty-package-state">
                  <h3 class="document-templates__empty-package-text">
                    У вас еще нет готовых пакетов документов
                  </h3>
                  <button
                    class="document-templates__create-package-btn"
                    title="Создать пакет"
                    type="button"
                    v-on:click="openCreatePackageModal"
                  >
                    Создать пакет
                  </button>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <support-contacts
        v-if="!isAwaitRequest && !hasCategories"
        class="document-templates__support"
        v-bind:title="titleSupportContacts"
        v-bind:is-show-mini-button-whats-app="true"
        v-bind:is-show-large-button-whats-app="false"
      />
    </div>
    <modal-dialog
      v-bind:title="templateRemoveTitle"
      v-bind:value="hasTemplateRemovalConfirmation"
      v-bind:with-cross="true"
      v-on:input="onTemplateRemovalConfirmationInput"
    >
      <div class="document-template-removal">
        <button
          class="document-template-removal__cancel"
          type="button"
          v-on:click="onTemplateRemovalConfirmationInput"
        >Отмена</button>
        <button
          class="document-template-removal__confirm"
          type="button"
          v-if="templateRemoveResolve"
          v-on:click="templateRemoveResolve"
        >Удалить</button>
      </div>
    </modal-dialog>
    <modal-dialog
      title="При удалении категории, все документы в ней будут удалены. Продолжить?"
      title-center
      max-width="500px"
      v-bind:value="isShowDeleteCategoryDialog"
      v-model="isShowDeleteCategoryDialog"
      with-cross
    >
      <confirm-modal
        confirm-title="Да, удалить"
        cancel-title="Нет"
        v-on:on-confirm="deleteCategory(selectedDeleteCategoryId)"
        v-on:on-cancel="isShowDeleteCategoryDialog = false"
      />
    </modal-dialog>
    <modal-dialog
      title="Создание пакета документов"
      v-model="isShowModalCreateNewPackage"
      v-bind:titleCenter="true"
      v-bind:withCross="true"
      v-bind:withPreviousButton="!isFirstStep"
      v-on:input="closeAllModalOfCreatingPackage"
      v-on:on-click-outside="closeAllModalOfCreatingPackage"
      v-on:on-previous-button="onPreviousButton"
      max-width="90%"
      width="700px"
    >
      <template
        v-if="isShowFirstStepModal">
        <input-text
          v-bind:title="`Название пакета`"
          v-bind:maxlength="$options.packageDocuments.maxLengthPackageName"
          v-bind:violations="packageInputError"
          v-model="packageName"
          required
        />
        <button
          class="document-templates__create-package-btn
          document-templates__create-package-btn--narrow"
          title="Далее"
          type="button"
          v-on:click="toSecondStep"
        >
          Далее
        </button>
      </template>
      <template
        v-if="isShowSecondStepModal">
        <div class="package-documents-selection">
          <div class="package-documents-selection">
            <v-expansion-panels>
              <accordion-templates-group
                v-for="category in categoriesWithTemplates"
                v-bind:key="category.categoryId"
                v-bind:group="category"
                v-bind:selected-templates="selectedTemplates"
                v-on:template-toggle="onTemplateToggle"
              />
            </v-expansion-panels>
            <button
              class="document-templates__create-package-btn
          document-templates__create-package-btn--narrow"
              :title="buttonTitle"
              type="button"
              v-bind:disabled="!isSelectedTemplatesEnough"
              v-on:click="toThirdStep"
            >
              Далее
            </button>
          </div>
        </div>
      </template>
      <template
        v-if="isShowThirdStepModal">
        <div class="package-creation-table">
          <div class="package-creation__row">
            <span class="package-creation__label">Пакет</span>
            <span class="package-creation__package-name">{{ packageName }}</span>
          </div>
          <div class="package-creation__row">
            <span class="package-creation__label">Состав:</span>
            <div class="package-creation__document-name">
              <div
                v-for="(template, index) in selectedTemplates.toArray()"
                v-bind:key="index"
                class="package-creation__document"
              >
                {{ template.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="package-creation__final-buttons-container">
          <button
            class="package-creation__btn-cancel"
            type="button"
            v-on:click="closeAllModalOfCreatingPackage">
            Отмена
          </button>
          <button
            class="package-creation__btn-create"
            type="button"
            v-on:click="createPackage"
          >
            Готово
          </button>
        </div>
      </template>
    </modal-dialog>
    <confirm-side-dialog
      v-bind:label="'Добавить'"
      v-bind:with-cross="true"
      v-if="isShowCreateForm"
      v-on:cancel="isShowCreateForm = false"
    >
      <form-document-template-item
        v-bind:categories="categories"
        v-bind:input-errors="inputErrors"
        v-on:on-download="onDownloadFile"
        v-on:on-create-category="createCategory"
        v-on:on-create-document-template="createDocumentTemplate"
        v-on:on-create-contract-template="createContractTemplate"
        v-on:on-preview-contract="previewContractTemplate"
        v-on:on-preview-document="previewDocumentTemplate"
        v-on:on-download-variables="downloadVariables"
        v-on:on-cancel="isShowCreateForm = false"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-bind:label="'Редактирование категории'"
      v-bind:with-cross="true"
      v-if="isShowFormEditCategory"
      v-on:cancel="isShowFormEditCategory = false"
    >
      <form-document-template-category-edit
        v-bind:input-errors="inputErrors"
        v-bind:initial-id="selectedCategoryForEdit.id"
        v-bind:initial-name="selectedCategoryForEdit.name"
        v-on:on-submit="editCategory"
        v-on:on-cancel="isShowFormEditCategory = false"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-bind:label="'Редактирование документа'"
      v-bind:with-cross="true"
      v-if="isShowEditTemplateSidebar"
      v-on:cancel="isShowEditTemplateSidebar = false">
      <form-system-clinic-document-template
        v-if="selectedCategoryId === $options.systemDocuments.id"
        v-bind:initial-template="selectedEditTemplate"
        v-bind:input-errors="inputErrors"
        v-on:submit="editSystemDocumentTemplate"
        v-on:download-file="onDownloadFile"
        v-on:download-variables="downloadSystemVariables"
        v-on:download-system-template="downloadSystemTemplate"
        v-on:cancel="isShowEditTemplateSidebar = false"
      />
      <form-edit-clinic-document-template
        v-else
        v-bind:input-errors="inputErrors"
        v-bind:initial-template="selectedEditTemplate"
        v-bind:categories="categories"
        v-on:cancel="isShowEditTemplateSidebar = false"
        v-on:submit-document="editDocumentTemplate"
        v-on:submit-contract="editContractTemplate"
        v-on:preview-contract="previewContractTemplate"
        v-on:preview-document="previewDocumentTemplate"
        v-on:download-file="onDownloadFile"
        v-on:download-variables="downloadVariables"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-bind:label="`Редактирование пакета '${selectedEditPackageTemplate.name}'`"
      v-bind:with-cross="true"
      v-if="isShowEditPackageTemplateSidebar"
      v-on:cancel="isShowEditPackageTemplateSidebar = false">
      <form-edit-clinic-package-template
        v-bind:initial-template="selectedEditPackageTemplate"
        v-bind:categories-with-templates="categoriesWithTemplates"
        v-on:cancel="isShowEditPackageTemplateSidebar = false"
        v-on:save-package="editPackageTemplate"
        v-bind:selected-edit-package-template="selectedEditPackageTemplate"
        v-on:template-toggle="onTemplateToggle"
        v-model="selectedTemplates" />
    </confirm-side-dialog>
  </main>
</template>

<script>
import InputTextSearch from '@/components/InputTextSearch.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import SupportContacts from '@/components/SupportContacts.vue';
import debounce from 'lodash.debounce';
import notifierMixin from '@/mixins/notifierMixin';
import { List } from 'monet';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import FormEditClinicDocumentTemplate from '@/components/FormEditClinicDocumentTemplate.vue';
import { CONTRACT_TYPE, DOCUMENT_TYPE } from '@/mixins/clinicTemplateMixin';
import CategoryItem from '@/components/CategoryItem.vue';
import FormDocumentTemplateItem from '@/components/FormDocumentTemplateItem.vue';
import FormDocumentTemplateCategoryEdit from '@/components/FormDocumentTemplateCategoryEdit.vue';
import FormSystemClinicDocumentTemplate from '@/components/FormSystemClinicDocumentTemplate.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import { SelectTemplate } from '@/storage/gateways/DocumentTemplateGateway';
import InputText from '../../components/InputText.vue';
import AccordionTemplatesGroup from '../../components/AccordionTemplatesGroup.vue';
import FormEditClinicPackageTemplate from '../../components/FormEditClinicPackageTemplate.vue';

/**
 * @description Сохранить файл.
 * @param file
 * @param name
 */
function saveFile(file, name) {
  const obj = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = obj;
  link.target = '_blank';
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

const SystemDocumentsMixin = {
  systemDocuments: {
    id: 'system-documents',
    name: 'Системные документы',
  },
  methods: {
    /**
     * @description Редактирование шаблона документа.
     * @param request {ClinicSystemTemplateRequestEdit}
     * @returns {void}
     */
    editSystemDocumentTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(this.selectedCategoryId);
        this.isShowEditTemplateSidebar = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editSystemClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Скачать системный документ.
     * @param id
     * @param name
     * @returns {void}
     */
    downloadSystemDocument(id, name) {
      const onSuccess = (response) => {
        saveFile(response, name);
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .downloadClinicSystemDocumentTemplate(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Скачать файл с переменными.
     * @returns {void}
     */
    downloadSystemVariables(type) {
      const onSuccess = (response) => {
        saveFile(response, 'Переменные.docx');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
      };
      this
        .$documentTemplateGateway
        .downloadSystemTemplateVariables(type)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Скачать файл с переменными.
     * @returns {void}
     */
    downloadSystemTemplate(type) {
      const onSuccess = (response) => {
        saveFile(response, 'Шаблон.docx');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
      };
      this
        .$documentTemplateGateway
        .downloadSystemTemplate(type)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
  },
  computed: {
    /**
     * @description Проверка, является ли текущая категория - категорией "Системные документы"
     * @returns {boolean}
     */
    isCurrentCategorySystemDocuments() {
      return this.selectedCategoryId === this.$options.systemDocuments.id;
    },
  },
};

/**
 * @description Идентификатор первого шага создания шаблонного Пакета документов/контрактов.
 * На этом шагу указывается название Пакета.
 * @type {number}
 */
const FIRST_STEP_OF_CREATING_PACKAGE = 1;

/**
 * @description Идентификатор второго шага создания шаблонного Пакета документов/контрактов.
 * На этом шагу указываются документы/контракты которые будут включены в Пакет
 * @type {number}
 */
const SECOND_STEP_OF_CREATING_PACKAGE = 2;

/**
 * @description Идентификатор третьего шага создания шаблонного Пакета документов/контрактов.
 * На этом шагу пользователь может посмотреть: название Пакета; документы/контракты, которые
 * будут включены в Пакет и нажать финальную кнопку - готово (для обращения на бэкенд)
 * @type {number}
 */
const THIRD_STEP_OF_CREATING_PACKAGE = 3;

/**
 * @description Минимальное количество выбранных шаблонов для формирования шаблонного
 * Пакета документов/контрактов
 * @type {number}
 */
const MIN_SELECTED_TEMPLATES_COUNT = 2;

const PackageDocumentsMixin = {
  packageDocuments: {
    id: 'package-documents',
    name: 'Пакеты документов',
    maxLengthPackageName: 1000,
  },
  computed: {
    /**
     * @description Проверка, является ли текущий шаг создания Пакета - первым?
     * @type {boolean}
     */
    isFirstStep() {
      return this.currentModalStep === FIRST_STEP_OF_CREATING_PACKAGE;
    },
    /**
     * @description Данный метод отвечает за отображения текста, при наведении на кнопку Далее
     * на втором этапе. Сам текст зависит количества выбранных пользователем шаблонов документов.
     * @return {string}
     */
    buttonTitle() {
      return this.isSelectedTemplatesEnough
        ? 'Далее'
        : 'Необходимо выбрать минимум 2 шаблона';
    },
    /**
     * @description Проверка, достаточно ли шаблонных документов/контрактов выбрал пользователь
     * для перехода на третий этап создания Пакета?
     * @type {boolean}
     */
    isSelectedTemplatesEnough() {
      return this.selectedTemplates.size() >= MIN_SELECTED_TEMPLATES_COUNT;
    },
    /**
     * @description Проверка, является ли текущая категория - категорией "Пакетов документов"
     * @returns {boolean}
     */
    isCurrentCategoryPackageDocuments() {
      return this.selectedCategoryId === this.$options.packageDocuments.id;
    },
  },
  methods: {
    /**
     * @description Получение всех шаблонов документов/контрактов сгруппированных по категориям
     * @returns {void}
     */
    fetchAllTemplates() {
      this.isAwaitRequest = true;
      this.$documentTemplateGateway.viewAllTemplatesListGroupByCategories()
        .then((result) => {
          result.forEach((categories) => {
            this.categoriesWithTemplates = List.fromArray(categories);
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать событие нажатия на кнопку "Назад".
     * @returns {void}
     */
    onPreviousButton() {
      switch (this.currentModalStep) {
        case SECOND_STEP_OF_CREATING_PACKAGE: this.toFirstStep(); break;
        case THIRD_STEP_OF_CREATING_PACKAGE: this.toSecondStep(); break;
        default: this.toFirstStep();
      }
    },
    /**
     * @description Обработать выбор/снятие шаблона.
     * @param {string} templateName
     * @param {string} templateType
     * @param {string} templateId
     * @param {boolean} isTemplateSample
     * @param {boolean} checked
     * @returns {void}
     */
    onTemplateToggle(templateName, templateType, templateId, isTemplateSample, checked) {
      if (checked === true) {
        this.selectedTemplates = this.selectedTemplates.append(
          List.of(new SelectTemplate(templateId, templateType, templateName, isTemplateSample)),
        );
      } else {
        this.selectedTemplates = this
          .selectedTemplates
          .filter((template) => !(template.id.toString() === templateId.toString()
            && template.type === templateType));
      }
    },
    /**
     * @description Обработать клик по категории Пакеты Документов.
     * Получение шаблонных Пакетов документов/контрактов для отображения Пакетов, которые
     * принадлежат клинике.
     */
    onSelectPackageDocuments() {
      this.isAwaitRequest = true;
      this.selectedCategoryId = this.$options.packageDocuments.id;
      this.$documentTemplateGateway.viewPackageList()
        .then((result) => {
          result.forEach((packages) => {
            this.packages = packages;
            this.isPackagesFind = this.packages.size() > 0;
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Проверка, данные нового шаблонного Пакета прошли проверку?
     * @returns {boolean}
     */
    isPackageInformationPassedValidate() {
      if (this.packageName === '') {
        this.notifyFail('Укажите название пакета');
        return false;
      }
      if (this.selectedTemplates.size() < MIN_SELECTED_TEMPLATES_COUNT) {
        this.notifyFail('Выберите минимум 2 документа для создания пакета');
        return false;
      }
      return true;
    },
    /**
     * @description Создать шаблонный Пакет документов/контрактов.
     * @returns {void}
     */
    createPackage() {
      if (this.isAwaitRequest === true) {
        return;
      }
      if (!this.isPackageInformationPassedValidate()) {
        return;
      }
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.closeAllModalOfCreatingPackage();
        this.onSelectPackageDocuments();
      };
      const onFail = (response) => {
        this.closeAllModalOfCreatingPackage();
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this.isAwaitRequest = true;
      const request = {
        name: this.packageName,
        templates: this.selectedTemplates.toArray().map((template) => ({
          id: template.id,
          type: template.type,
          is_sample: template.isSample,
        })),
      };
      this.$documentTemplateGateway.createPackageDocuments(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Открытие модального окна создания шаблонного Пакета документов/контрактов
     */
    openCreatePackageModal() {
      this.selectedTemplates = List();
      this.isShowModalCreateNewPackage = true;
      this.isShowFirstStepModal = true;
    },
    /**
     * @description закрытие модального окна создания нового шаблонного Пакета. Все данные очищаются
     */
    closeAllModalOfCreatingPackage() {
      this.packageName = '';
      this.currentModalStep = 1;
      this.packageInputError = [];
      this.selectedTemplates = List();
      this.isShowFirstStepModal = false;
      this.isShowThirdStepModal = false;
      this.isShowSecondStepModal = false;
      this.isShowModalCreateNewPackage = false;
    },
    /**
     * @description Перейти к первому шагу создания нового шаблонного Пакета документов/контрактов
     */
    toFirstStep() {
      this.currentModalStep = FIRST_STEP_OF_CREATING_PACKAGE;
      this.isShowSecondStepModal = false;
      this.isShowFirstStepModal = true;
    },
    /**
     * @description Перейти ко второму шагу создания нового шаблонного Пакета документов/контрактов
     */
    toSecondStep() {
      if (this.packageName === '') {
        this.packageInputError = ['Введите название пакета'];
        return;
      }
      this.packageInputError = [];
      this.fetchAllTemplates();
      this.currentModalStep = SECOND_STEP_OF_CREATING_PACKAGE;
      this.isShowFirstStepModal = false;
      this.isShowSecondStepModal = true;
      this.isShowThirdStepModal = false;
    },
    /**
     * @description Перейти к третьем шагу создания нового шаблонного Пакета документов/контрактов
     */
    toThirdStep() {
      if (this.selectedTemplates.size() < 2) {
        this.notifyFail('Выберите минимум 2 документа для создания пакета');
        return;
      }
      this.currentModalStep = THIRD_STEP_OF_CREATING_PACKAGE;
      this.isShowSecondStepModal = false;
      this.isShowThirdStepModal = true;
    },
    /**
     * @description Обработать событие нажатия по названию шаблонного Пакета. Появится сайдбар
     * редактирования шаблонного Пакета
     * @param {Package} packageTemplate
     */
    onClickPackageTemplateEditButton(packageTemplate) {
      this.selectedEditPackageTemplate = packageTemplate;
      this.selectedTemplates = packageTemplate.internalDocuments;
      this.inputErrors = {};
      this.fetchAllTemplates();
      this.isShowEditPackageTemplateSidebar = true;
    },
    /**
     * @description Редактирование шаблонного Пакета.
     * @returns {void}
     */
    editPackageTemplate() {
      const selectedTemplatesFromEditPackage = this.selectedTemplates.toArray();
      const selectedPackageId = this.selectedEditPackageTemplate.id;
      const isPackageTemplatesWereChanged = this.isPackageTemplatesWereChanged(
        selectedTemplatesFromEditPackage,
        this.selectedEditPackageTemplate.internalDocuments.toArray(),
      );
      if (!isPackageTemplatesWereChanged) {
        return;
      }
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.isShowEditTemplateSidebar = false;
        this.onSelectPackageDocuments();
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      const request = {
        templates: selectedTemplatesFromEditPackage.map((template) => ({
          id: template.id,
          type: template.type,
          is_sample: template.isSample,
        })),
      };
      this
        .$documentTemplateGateway
        .editClinicPackageDocumentTemplate(request, selectedPackageId)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Проверка, были ли изменены шаблоны пакета
     *
     * @param selectedTemplatesFromRequest
     * @param currentPackageTemplates
     * @returns {boolean}
     */
    isPackageTemplatesWereChanged(selectedTemplatesFromRequest, currentPackageTemplates) {
      if (selectedTemplatesFromRequest.length !== currentPackageTemplates.length) {
        return true;
      }
      const requestKeys = selectedTemplatesFromRequest
        .map((doc) => `${doc.id}_${doc.type}`)
        .sort();
      const currentKeys = currentPackageTemplates
        .map((doc) => `${doc.id}_${doc.type}`)
        .sort();
      return JSON.stringify(requestKeys) !== JSON.stringify(currentKeys);
    },
  },

  data() {
    return {
      /**
       * @description Список полученных Шаблонных Пакетов документов/контрактов для отображения.
       * @type {List<Package>}
       */
      packages: List(),
      /**
       * @description Список выбранных шаблонов документов/контрактов для шаблонного Пакета.
       * @type {List<SelectTemplate>}
       */
      selectedTemplates: List(),
      /**
       * @description Список категорий с шаблонами.
       * @type {List<CategoryWithTemplates>}
       */
      categoriesWithTemplates: List(),
      /**
       * @description Флаг. Размер списка шаблонных Пакетов документов/контрактов больше 0?
       * @type {boolean}
       */
      isPackagesFind: false,
      /**
       * @description Флаг. Показывать ли главное модальное окно, содержащее в себе
       * все шаги создания нового пакета?
       * @type {boolean}
       */
      isShowModalCreateNewPackage: false,
      /**
       * @description Флаг. Показывать ли модальное окно первого шага создания нового Пакета?
       * @type {boolean}
       */
      isShowFirstStepModal: false,
      /**
       * @description Флаг. Показывать ли модальное окно второго шага создания нового Пакета?
       * @type {boolean}
       */
      isShowSecondStepModal: false,
      /**
       * @description Флаг. Показывать ли модальное окно третьего шага создания нового Пакета?
       * @type {boolean}
       */
      isShowThirdStepModal: false,
      /**
       * @description Введенное название нового шаблонного Пакета документов/контрактов
       * @type{String}
       */
      packageName: '',
      /**
       * @description Текущий шаг создания шаблонного Пакета.
       * @type{number}
       */
      currentModalStep: 1,
      /**
       * @description Ошибка при вводе названия шаблонного Пакета
       * @type {Array}
       */
      packageInputError: [],
      /**
       * @description Выбранный шаблонный Пакет на редактирование.
       * @type {Package}
       */
      selectedEditPackageTemplate: null,
      /**
       * @description Показывать ли сайдбар редактирования шаблонного Пакета.
       * @type {Boolean}
       */
      isShowEditPackageTemplateSidebar: false,
    };
  },
};

export default {
  components: {
    FormEditClinicPackageTemplate,
    AccordionTemplatesGroup,
    InputText,
    ConfirmModal,
    FormDocumentTemplateCategoryEdit,
    FormDocumentTemplateItem,
    CategoryItem,
    FormEditClinicDocumentTemplate,
    ConfirmSideDialog,
    InputTextSearch,
    ModalDialog,
    SupportContacts,
    FormSystemClinicDocumentTemplate,
  },
  computed: {
    /**
     * @description Имеются категории.
     * @type {boolean}
     */
    hasCategories() {
      return this.categories.length > 0;
    },
    /**
     * @description Имеет подтверждение для удаления шаблона.
     */
    hasTemplateRemovalConfirmation() {
      return this.templateRemoveResolve !== null;
    },
    /**
     * @description Определяет, нужно ли показывать кнопку "Создать пакет".
     * Кнопка показывается только когда:
     * 1. Есть интеграция с F.doc
     * 2. Текущая категория - "Пакеты документов"
     * 3. Найдены пакеты документов
     * @returns {boolean}
     */
    shouldShowCreatePackageButton() {
      return this.isFdocIntegratonExists
        && this.isCurrentCategoryPackageDocuments
        && this.isPackagesFind;
    },
  },
  async created() {
    await this.fetchCategories();
    this.fetchTemplatesByFirstCategory();
  },
  data() {
    return {
      /**
       * @description Показывать ли диалоговое окно удаления категории.
       * @type {boolean}
       */
      isShowDeleteCategoryDialog: false,
      /**
       * @description Редактируемая категория.
       * @type {Object}
       */
      selectedCategoryForEdit: null,
      /**
       * @description Выбранная категория для удаления.
       * @type {String}
       */
      selectedDeleteCategoryId: '',
      /**
       * @description Показывать ли форму редактирования категории.
       * @type {boolean}
       */
      isShowFormEditCategory: false,
      /**
       * @description Выбранная категория шаблона лечения
       * @type {string}
       */
      selectedCategoryId: '',
      /**
       * @description Категории
       * @type Array
       */
      categories: [],
      /**
       * @description Флаг. Найдена ли интеграция с F.doc?
       * (Влияет на показ категории Пакеты Документов)
       * @type
       */
      isFdocIntegratonExists: false,
      /**
       * @description Показывать ли сайдбар редактирования шаблона.
       * @type {Boolean}
       */
      isShowEditTemplateSidebar: false,
      /**
       * @description Выбранный шаблон на редактирование.
       * @type {Template}
       */
      selectedEditTemplate: null,
      /**
       * @description Показывать ли сайдбар создания шаблона.
       * @type {Boolean}
       */
      isShowCreateForm: false,
      /**
       * @description Разрешение удаления шаблона.
       * @type {(function|null)}
       */
      templateRemoveResolve: null,
      /**
       * @description Заголовок удаления шаблона.
       * @type {string}
       */
      templateRemoveTitle: '',
      /**
       * @description Список шаблонов.
       * @type {List<Template>}
       */
      templates: List(),
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Заголовок блока контактов поддержки.
       * @type {string}
       */
      titleSupportContacts: 'Для автозаполнения и скачивания документов отправьте нам шаблоны '
        + 'документов вашей клиники (договор, согласие на обработку персональных данных и т.д.), '
        + 'мы сами загрузим их в МИС. \n\n Ваш менеджер Татьяна',
      searchQuery: '',
    };
  },
  methods: {
    /**
     * @description Затянуть шаблоны из первой категории
     * @returns {void}
     */
    fetchTemplatesByFirstCategory() {
      const categoryId = this.categories[0]?.id;
      if (categoryId) {
        this.onSelectCategory(categoryId);
      }
    },
    /**
     * @description Удалить категорию
     * @param {number} id
     * @returns {void}
     */
    deleteCategory(id) {
      this.isShowDeleteCategoryDialog = false;
      const onSuccess = async (response) => {
        this.notifySuccess(response.title);
        await this.fetchCategories();
        this.fetchTemplatesByFirstCategory();
        this.deleteCategoryDialog = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .deleteDocumentCategory(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создать категорию.
     * @param {DocumentCategoryCreateRequest} request
     * @returns {void}
     */
    createCategory(request) {
      const onSuccess = async (response) => {
        this.notifySuccess(response.title);
        await this.fetchCategories();
        this.onSelectCategory(response.id);
        this.isShowCreateForm = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .createDocumentCategory(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать события показа формы редактирования категории.
     * @param id
     * @returns {void}
     */
    onShowEditCategoryForm(id) {
      this.selectedCategoryForEdit = this.categories.find((el) => el.id === id);
      this.inputErrors = {};
      this.isShowFormEditCategory = true;
    },

    /**
     * @description Обработать событие выбора категории.
     * @param id
     * @returns {void}
     */
    onSelectCategory(id) {
      this.selectedCategoryId = id;
      this.fetchTemplates(id);
    },

    /**
     * @description Сохранить изменённую категорию.
     * @param {DocumentCategoryEditRequest} request
     * @returns {void}
     */
    editCategory(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.fetchCategories();
        this.isShowFormEditCategory = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editDocumentCategory(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Затянуть категории.
     * @returns {void}
     */
    async fetchCategories() {
      this.isAwaitRequest = true;
      const onSuccess = (response) => {
        this.categories = response.data.categories;
        this.isFdocIntegratonExists = response.data.is_fdoc_integration_exists;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      await this
        .$documentTemplateGateway
        .getDocumentCategories()
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Отобразить диалог удаления категории.
     * @param {Number} categoryId
     * @returns {void}
     */
    onShowDeleteCategoryForm(categoryId) {
      this.selectedDeleteCategoryId = categoryId;
      this.isShowDeleteCategoryDialog = true;
    },
    /**
     * @description Скачать файл с переменными.
     * @returns {void}
     */
    downloadVariables() {
      const onSuccess = (response) => {
        saveFile(response, 'Переменные.docx');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
      };
      this
        .$documentTemplateGateway
        .downloadTemplateVariables()
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Редактирование шаблона документа.
     * @param request {ClinicTemplateRequestEdit}
     * @returns {void}
     */
    editDocumentTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowEditTemplateSidebar = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Предпросмотр шаблона документа.
     * @param request {ClinicTemplateRequestPreview}
     * @returns {void}
     */
    previewDocumentTemplate(request) {
      const onSuccess = (response) => {
        window.open(URL.createObjectURL(response), '_blank');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .previewClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Предпросмотр шаблона документа.
     * @param {string} id
     * @param {string} type
     * @returns {void}
     */
    previewSampleTemplate(id, type) {
      const onSuccess = (response) => {
        window.open(URL.createObjectURL(response), '_blank');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .previewSampleTemplate(id, type)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestPreview}
     * @returns {void}
     */
    previewContractTemplate(request) {
      const onSuccess = (response) => {
        window.open(URL.createObjectURL(response), '_blank');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .previewClinicContractTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Редактировать шаблона документа.
     * @param request {ClinicTemplateRequestEdit}
     * @returns {void}
     */
    editContractTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowEditTemplateSidebar = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editClinicContractTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },

    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestCreate}
     * @returns {void}
     */
    createDocumentTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowCreateForm = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .storeClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создание шаблона договора.
     * @param request {ClinicTemplateRequestCreate}
     * @returns {void}
     */
    createContractTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowCreateForm = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .storeClinicContractTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать событие нажатия на кнопку добавления шаблона.
     * @returns {void}
     */
    onClickAddTemplate() {
      this.inputErrors = {};
      this.isShowCreateForm = true;
    },
    /**
     * @description Обработать ввод запроса.
     * @type {string} value
     * @returns {void}
     */
    onInputSearchQuery(value) {
      this.searchQuery = value;
    },
    /**
     * @description Обработать ввод диалога подтверждения при удалении шаблона.
     * @param {boolean} value Значение.
     * @returns {void}
     */
    onTemplateRemovalConfirmationInput(value) {
      if (value !== true) {
        this.templateRemoveResolve = null;
        this.templateRemoveTitle = '';
      }
    },
    /**
     * @description Обработать событие нажатия на кнопку редактирования шаблона.
     * @param {Template} template
     */
    onClickTemplateEditButton(template) {
      this.selectedEditTemplate = template;
      this.inputErrors = {};
      this.isShowEditTemplateSidebar = true;
    },
    /**
     * @description Обработать событие нажатия на кнопку скачать шаблон образца.
     * @param {Template} template
     */
    onClickSampleTemplateDownloadButton(template) {
      this.downloadSampleTemplate(template.id, template.type, template.name);
    },
    /**
     * @description Обработать событие нажатия на кнопку предпросмотр шаблона образца.
     * @param {Template} template
     */
    onClickSampleTemplatePreviewButton(template) {
      this.previewSampleTemplate(template.id, template.type);
    },
    /**
     * @description Обработать удаление шаблона.
     * @param {string} templateId Идентификатор шаблона.
     * @param {string} type       Тип шаблона.
     * @returns {void}
     */
    onTemplateRemove(templateId, type) {
      (new Promise((resolve) => {
        this.templateRemoveResolve = () => resolve(templateId);
        this.templateRemoveTitle = `Вы точно хотите удалить ${type}?`;
      }))
        .then((confirmedTemplateId) => {
          this.$documentTemplateGateway.deleteTemplate(confirmedTemplateId).then((result) => {
            result.forEachLeft(({ title }) => {
              this.notifyFail(title);
            });
            result.forEach(({ title }) => {
              this.fetchTemplates();
              this.notifySuccess(title);
            });
          });
        })
        .finally(() => {
          this.templateRemoveResolve = null;
          this.templateRemoveTitle = '';
        });
    },
    /**
     * @description Получить список шаблонов.
     * @returns {void}
     */
    fetchTemplates() {
      if (this.isCurrentCategoryPackageDocuments) {
        return;
      }
      this.isAwaitRequest = true;
      this.$documentTemplateGateway.viewList(this.searchQuery, this.selectedCategoryId)
        .then((result) => {
          result.forEach((list) => {
            this.templates = List.fromArray(list);
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать событие загрузки файла.
     *
     * @param {Object} request
     *
     * @returns {void}
     */
    onDownloadFile(request) {
      const { file, type } = request;
      if (file) {
        this.downloadExistFile(file.id, file.name, type);
      }
      saveFile(request, request.name);
    },
    /**
     * @description Скачать существующий файл
     * @param id
     * @param name
     * @param type
     * @returns {void}
     */
    downloadExistFile(id, name, type) {
      if (this.selectedCategoryId === this.$options.systemDocuments.id) {
        this.downloadSystemDocument(id, name);
      }
      if (type === DOCUMENT_TYPE) {
        this.downloadDocument(id, name);
      }
      if (type === CONTRACT_TYPE) {
        this.downloadContract(id, name);
      }
    },

    /**
     * @description Скачать документ
     * @param id
     * @param name
     * @returns {void}
     */
    downloadDocument(id, name) {
      const onSuccess = (response) => {
        saveFile(response, name);
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .downloadClinicDocumentTemplate(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },

    /**
     * @description Скачать образец документа
     * @param {string} id
     * @param {string} type
     * @param {string} name
     * @returns {void}
     */
    downloadSampleTemplate(id, type, name) {
      const onSuccess = (response) => {
        saveFile(response, `ОБРАЗЕЦ ${name}`);
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .downloadSampleTemplate(id, type)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Загрузить договор.
     * @param id
     * @param name
     * @returns {void}
     */
    downloadContract(id, name) {
      const onSuccess = (response) => {
        saveFile(response, name);
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .downloadClinicContractTemplate(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
  },
  mixins: [
    notifierMixin,
    SystemDocumentsMixin,
    PackageDocumentsMixin,
  ],
  name: 'ClinicPanelClinicDocumentTemplateList',
  watch: {
    searchQuery: {
      handler: debounce(async function _() {
        await this.fetchTemplates();
      }, 300),
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.document-template-removal {
  display: flex;
  flex-direction: row;
  gap: .75rem;
  & &__cancel,
  & &__confirm {
    @include buttons.btn-transparent(10rem, 2rem, 1rem);
  }
  & &__confirm,
  & &__confirm:hover {
    border: 1px solid var(--warning-color);
    color: var(--warning-color);
  }
}

.document-templates {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  &__controls {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px 25px;
  }
  &__button-add {
    @include buttons.btn-blue(100%, 48px, 16px);
    white-space: nowrap;
    max-width: 200px;
    height: 50px;
    min-width: 140px;
  }
  &__button-create-package {
    @include buttons.btn-blue(100%, 48px, 16px);
    white-space: nowrap;
    max-width: 200px;
    height: 50px;
    min-width: 140px;
  }
  &__buttons-group {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
  }
  &__empty-package-state {
    display: flex;
    flex-direction: column;
    gap: 25px;
    align-items: center;
    margin-top: 25px;
    text-align: center;
    &__empty-package-text {
      margin-bottom: 10px;
    }
  }
  &__create-package-btn {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 200px;
    height: 50px;
    &--narrow {
      margin-top: 20px;
      max-width: 120px;
      margin-left: auto;
      display: block;
    }
  }
  &__body {
    display: grid;
    gap: 2rem;
    padding: 38px 20px 48px 23px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &__search {
    max-width: 515px;
    margin-bottom: 20px;
  }
  &__tables-container {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 10px;
  }
  &__categories {
    width: 280px;
    &__caption {
      font-size: 14px;
      line-height: 17px;
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 6px 10px 14px;
    }
    &__container {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 280px;
      background: #f2f7fa;
      padding: 20px 10px;
    }
  }
  &__table {
    counter-reset: counterEmployees;
    overflow-x: auto;
    &:empty {
      display: none;
    }
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 60px 1fr 1fr repeat(4, 43px);
      grid-gap: 4px;
      align-items: center;
      min-width: 800px;
      font-size: 14px;
      line-height: 17px;
    }
    &__row {
      width: 100%;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #eaeff3;
      padding: 12px 0;
    }
    &__cell {
      text-align: left;
      padding: 0 8px;
      &__button-package-edit {
        text-align: left;
        &:hover {
          color: var(--action-color);
        }
      }
    }
  }
  &__table-row-remove {
    @include buttons.btn-cross-remove(100%);
  }
  &__table-row-edit {
    @include buttons.btn-pen-edit(100%);
  }
  &__table-row-view {
    @include buttons.btn-view(100%);
  }
  &__table-row-download {
    @include buttons.btn-download(100%);
  }
  &__support {
    background-color: transparent !important;
    padding: 0 !important;
    .support-contacts__caption,
    .support-contacts__tel,
    .support-contacts__email {
      font-size: 16px;
      line-height: 25px;
    }
    .support-contacts__button {
      font-size: 16px;
    }
  }
}

.package-creation {
  &__final-buttons-container {
    display: flex;
    justify-content: center;
    flex-direction: row;
    gap: 10px;
  }
  &__btn-cancel {
    @include buttons.btn-transparent(100%, 48px, 16px);
    max-width: 100px;
    height: 33px;
  }
  &__btn-create {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 100px;
    height: 33px;
  }
  &__label {
    vertical-align: top;
    color: #000000de;
  }
  &__package-name {
    color: #000000de;
  }
  &__document-name {
    color: #000000de;
  }
  &__row {
    gap: 5px;
    display: grid;
    grid-template-columns: 60px 1fr;
  }
}
</style>
